// import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors";
import formatDate from "../../utils/functions/formatDate";
import plus_icone from "../../assets/images/icones/plus-icone.png";
import minus_icone from "../../assets/images/icones/minus-icone.png";
import { useState, useEffect } from "react";
import ModalInfoChange from "./ModalInfoChange";
import ModalDevisFacture from "./ModalDevisFacture";
import imgCalend from "../../assets/images/icones/calendar.png";
import imgTrash from "../../assets/images/icones/trash.png";

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
`;

const ModalContainer = styled.div`
    position: absolute;
    background: black;
    color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    /* width: 800px; */
    /* height: 650px; */
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
        font-size: 1.4rem;
    }
    h2 {
        color: ${colors.primary};
        margin: 10px;
    }
    select {
        font-size: 1.3rem;
        font-weight: bold;
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }
    .nameSuppr {
        color: ${colors.tertiary};
        font-size: 1.6rem;
        font-weight: bold;
    }
    .warning {
        color: ${colors.primary};
        font-weight: bold;
    }
    span.yellow {
        color: ${colors.primary};
    }
    span.pink {
        color: ${colors.tertiary};
    }
    span.blue {
        color: ${colors.secondary};
    }
    .infosCardContainer {
        display: flex;

        gap: 10px;
    }
`;

const ChoiceButtons = styled.div`
    .btnModal {
        padding: 10px 15px;
        border-radius: 4px;
        border: none;
        margin: 20px;
        color: #fff;
        cursor: pointer;
    }
    .btnModal1 {
        background-color: #007bff;
        margin-top: 0;
    }
    .btnModal2 {
        background-color: rgb(249, 64, 64);
    }
`;

const InfosCard = styled.div`
    border: 1px solid ${colors.primary};
    padding: 20px;
    margin-top: 15px;
    border-radius: 10px;
    text-align: start;
    p {
        padding: 0;
    }
    h2 {
        margin: 0;
        text-decoration: underline;
    }
    li {
        list-style: none;
        font-size: 1.4rem;
    }

    .addDeleteBtn {
        background-color: #b2b2b2;
        border-radius: 8px;
        border: 3px solid white;
        margin: 0 3px;
        > img {
            width: 20px;
            margin: 2px;
        }
        :hover {
            cursor: pointer;
        }
    }
    .titreListe {
        display: flex;
        align-content: center;
        > span {
            margin-right: 10px;
        }
    }

    .btnDownLoad {
        background-color: transparent;
        color: ${colors.secondary};
        border: none;
        font-size: 1.4rem;

        &:hover {
            cursor: pointer;
        }
    }

    /*  code pour changer l'icone native des navigateurs pour l'input date.... from ChatGPT  */
    .custom-date-button {
        position: relative;
        display: inline-flex; /* Garde le bouton bien aligné sans le faire remonter */
        /* align-items: center;
        justify-content: center; */
        width: 40px; /* Ajuster la taille du bouton */
        height: 40px;
        /* transform: translateY(-3px); */
    }

    /* Rendre l'input invisible mais toujours fonctionnel */
    .custom-date-button input[type="date"] {
        appearance: none;
        -webkit-appearance: none;
        opacity: 0; /* Masquer totalement l'input */
        width: 100%;
        height: 100%;
        /* display: flex;
        align-items: center;
        justify-content: center; */
        /* cursor: pointer; */
        z-index: 2; /* Rendre cliquable */
    }

    /* Masquer l'icône native du date-picker */
    .custom-date-button input[type="date"]::-webkit-calendar-picker-indicator {
        /* position: absolute; */
        width: 100%;
        height: 100%;
        cursor: pointer;
        z-index: 3;
    }

    /* Style du bouton icône */
    .custom-date-button .icon {
        width: 100%;
        height: 100%;
        background-color: #b2b2b2;
        border: 3px solid white;
        border-radius: 8px;
        cursor: pointer;
        font-size: 20px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        /* transform: translateY(-3px); */
    }
    select#typeEtape {
        background-color: #ccc;
        border: 3px solid white;
        padding: 5px;
        width: auto;
    }
    select#typeEtape option {
        color: black;
        font-weight: 400;
        background-color: #fff;
    }

    .dateAffich {
        padding: 0 8px;
    }

    .iconTrash {
        background-color: rgb(249, 64, 64);
        border-radius: 8px;
        border: 3px solid white;
        margin: 0 20px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 40px; /* Ajuster la taille du bouton */
        height: 40px;
        /* transform: translateY(-3px); */
        > img {
            width: 22px;
            /* margin: 2px; */
        }
        :hover {
            cursor: pointer;
        }
    }

    .dateEtape {
        display: flex;
        justify-content: start;
        align-items: center;
    }
`;

const ModalInfosProjet = ({
    handleClose,
    infosProjet,
    handleProjet,
    setRefreshFlag,
}) => {
    const [showModalInfosProjetChange, setShowModalInfosProjetChange] =
        useState(false);
    const [mode, setMode] = useState("");
    const [listUser, setListUser] = useState([]);

    const [showModalDevisFacture, setShowModalDevisFacture] = useState(false);
    const [typeDF, setTypeDF] = useState("");

    useEffect(() => {
        if (mode === "addUser") {
            // création de la liste de users CRM disponible chez Enea et entreprise concernée par l'offre.
                    
            const prepareListUserByEnt = async () => {
                try {
                    const apiUrl = process.env.REACT_APP_API_URL;
                    const response = await fetch(
                        `${apiUrl}/api/admin/findUsers`,
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                IdEntreprise: infosProjet.IdEntreprise,
                                CRMUsersId: infosProjet.CRMUsers.map(
                                    (user) => user.id
                                ),
                            }),
                        }
                    );
                    const data = await response.json();

                    if (!response.ok) {
                        console.error("Erreur de chargement des users", data);
                    } else {
                        setListUser(data);
                    }
                } catch (error) {
                    console.error(
                        "Erreur lors de la récupération des contacts",
                        error
                    );
                }
            };

            prepareListUserByEnt();
        }
    }, [mode, infosProjet]);

    const tabAntenne = {
        Be: "Bénin",
        CI: "Côte d'Ivoire",
        To: "Togo",
        All: "Toutes",
        BF: "Burkina Faso",
    };

    const statutLabels = {
        OG: { className: "OG", label: "Offre gagnée" },
        PR: { className: "PR", label: "Phase de réalisation" },
        PA: { className: "PA", label: "Projet achevé" },
        EC: { className: "EC", label: "En cours/Bloquée" },
        OA: { className: "OA", label: "Offre annulée" },
        OP: { className: "OP", label: "Offre perdue" },
        AR: { className: "AR", label: "Offre à relancer" },
    };

    const listStatutDevis = ["EC", "AR"];
    const listStatutFacture = ["PR", "PA"];

    const handleCloseInfoChange = () => {
        setMode("");
        handleProjet(infosProjet.id);
        setShowModalInfosProjetChange(false);
    };

    const handleClick = (mode) => {
        setMode(mode);
        setShowModalInfosProjetChange(true);
    };

    const handleClickDF = (type) => {
        setTypeDF(type);
        setShowModalDevisFacture(true);
    };

    const handleCloseDF = () => {
        setTypeDF("");
        handleProjet(infosProjet.id);
        setShowModalDevisFacture(false);
    };

    const handleDownLoad = async (id, nom) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/documents/downloadFile`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        docId: id,
                    }),
                }
            );

            if (!response.ok) {
                console.error("Erreur lors du téléchargement du document");
            } else {
                const blob = await response.blob(); // Convertir la réponse en blob
                const url = window.URL.createObjectURL(blob); // Créer un lien vers le blob
                const link = document.createElement("a"); // Créer un élément <a>
                link.href = url;
                link.setAttribute("download", nom); // Nom du fichier à télécharger
                document.body.appendChild(link);
                link.click(); // Simuler le clic
                // Nettoyage après le téléchargement
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url); // Libérer l'URL du blob // Supprimer le lien après le téléchargement
            }
        } catch (error) {
            console.error("Erreur lors du téléchargement", error);
        }
    };

    const updateDateEtape = async (event, id) => {
        try {
            const formData = new FormData();
            formData.append("content", "updateDateEtape");
            formData.append("data", event.currentTarget.value);
            formData.append("projet_id", id);
            formData.append("targetId", event.currentTarget.id);
            // ne servent que pour changement de statut
            formData.append("file", null);
            formData.append("montantOG", null);
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/admin/projet/update`, {
                method: "POST",
                credentials: "include",

                body: formData,
            });
            const dataResponse = await response.json();

            if (!response.ok) {
                console.error(
                    "Erreur de chargement des contacts" + dataResponse.error
                );
            } else {
                setRefreshFlag((prev) => !prev);
                handleProjet(infosProjet.id);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des contacts", error);
        }
    };

    // * Fonction pour éviter l'erreur de l'affichage du date-picker (même si dans mon cas cet affichage est masqué!!!)
    const convertToISODate = (datetime) => {
        if (!datetime) {
            // Si la date est null, undefined ou vide, retourne une chaîne vide
            return "";
        }
        // Convertir la chaîne datetime en objet Date
        const date = new Date(datetime);

        // Obtenir les composantes de la date
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Mois (1 à 12)
        const day = String(date.getDate()).padStart(2, "0"); // Jour (01 à 31)

        // Retourner la date au format YYYY-MM-DD
        return `${year}-${month}-${day}`;
    };

    return (
        <Modal>
            <ModalContainer>
                <div>
                    <h2>Détails sur l'offre/le projet: </h2>
                    <p>
                        <span className="pink">{infosProjet.nom}</span>{" "}
                    </p>
                    <p>
                        <span className="yellow">Numéro d'offre:</span>{" "}
                        <span className="pink">{infosProjet.numero_offre}</span>{" "}
                    </p>
                    <p>
                        <span className="yellow">Entreprise:</span>{" "}
                        {infosProjet.entreprise}{" "}
                        <span className="yellow">Antenne:</span>{" "}
                        <span className="pink">
                            {tabAntenne[infosProjet.antenneEnea]}
                        </span>
                    </p>
                    <div className="infosCardContainer">
                        <div>
                            <InfosCard>
                                <h2 className="yellow">
                                    Informations générales:
                                </h2>{" "}
                                <p>
                                    <span className="yellow">
                                        Date de création de l'offre:
                                    </span>{" "}
                                    {formatDate(infosProjet.dateCreation.date)}
                                </p>
                                <p>
                                    <span className="yellow">
                                        Montant de l'offre:
                                    </span>{" "}
                                    {infosProjet.montant} FCFA -{" "}
                                    {Math.round(
                                        infosProjet.montant * 0.001524 * 100
                                    ) / 100}{" "}
                                    €
                                </p>
                                <p>
                                    <span className="yellow">Objectif:</span>{" "}
                                    {infosProjet.objetcif ?? "Non renseigné"}
                                </p>
                                <p>
                                    <span className="yellow">Description:</span>{" "}
                                    {infosProjet.description ?? "Non renseigné"}
                                </p>
                                <p>
                                    <span className="yellow">Statut:</span>{" "}
                                    {statutLabels[infosProjet.statut].label}
                                </p>
                                <p className="dateEtape">
                                    <span className="yellow">Date Etape:</span>{" "}
                                    <span className="dateAffich">
                                        {infosProjet.date_etape
                                            ? formatDate(
                                                  infosProjet.date_etape.date
                                              )
                                            : "Non définie"}
                                    </span>
                                    <span className="custom-date-button">
                                        <input
                                            type="date"
                                            name="dateEtape"
                                            id="dateEtape"
                                            value={
                                                infosProjet.date_etape
                                                    ? convertToISODate(
                                                          infosProjet.date_etape
                                                              .date
                                                      )
                                                    : ""
                                            }
                                            onInput={(event) =>
                                                updateDateEtape(
                                                    event,
                                                    infosProjet.id
                                                )
                                            }
                                        />
                                        <span className="icon">
                                            {" "}
                                            <img
                                                src={imgCalend}
                                                alt="calendrier"
                                                height="20px"
                                            />{" "}
                                        </span>{" "}
                                    </span>
                                    <select
                                        name="typeEtape"
                                        id="typeEtape"
                                        value={infosProjet?.type_etape ?? ""}
                                        onChange={(event) =>
                                            updateDateEtape(
                                                event,
                                                infosProjet.id
                                            )
                                        }
                                    >
                                        <option value="">-- Type --</option>
                                        <option value="Soumission">
                                            Soumission
                                        </option>
                                        <option value="Relance">Relance</option>
                                    </select>
                                    <button
                                        className="iconTrash"
                                        title="Effacer les données Date Etape"
                                        value=""
                                        id="dateEtapeTrash"
                                        onClick={(event) =>
                                            updateDateEtape(
                                                event,
                                                infosProjet.id
                                            )
                                        }
                                    >
                                        <img src={imgTrash} alt="Poubelle" />
                                    </button>{" "}
                                </p>
                                <p>
                                    {infosProjet.dateDebPrev?.date
                                        ? (
                                              <span className="yellow">
                                                  Date de début de chantier
                                                  prévisionnelle:{" "}
                                              </span>
                                          ) +
                                          formatDate(
                                              infosProjet.dateDebPrev.date
                                          ) +
                                          <br></br>
                                        : null}{" "}
                                    {infosProjet.dateFinPrev?.date
                                        ? (
                                              <span className="yellow">
                                                  Date de fin de chantier
                                                  prévisionnelle:{" "}
                                              </span>
                                          ) +
                                          formatDate(
                                              infosProjet.dateFinPrev.date
                                          ) +
                                          <br></br>
                                        : null}{" "}
                                    {/* ci-dessous dates de débuts et fin réelles si il y a lieu de l'afficher! */}
                                    {infosProjet.statut === "PR" ||
                                    infosProjet.statut === "PA" ||
                                    infosProjet.statut === "OG" ? (
                                        <>
                                            <span className="yellow">
                                                Numéro du contrat:{" "}
                                            </span>
                                            {infosProjet.numero_contrat
                                                ? formatDate(
                                                      infosProjet.numero_contrat
                                                  )
                                                : "Non renseigné"}
                                            <br></br>
                                        </>
                                    ) : null}
                                    {infosProjet.statut === "PR" ||
                                    infosProjet.statut === "PA" ? (
                                        <>
                                            <span className="yellow">
                                                Date réelle de début de
                                                chantier:{" "}
                                            </span>
                                            {infosProjet.dateDebReel
                                                ? formatDate(
                                                      infosProjet.dateDebReel
                                                          .date
                                                  )
                                                : "Non renseignée"}
                                            <br></br>
                                        </>
                                    ) : null}
                                    {infosProjet.statut === "PA" ? (
                                        <>
                                            <span className="yellow">
                                                Date réelle de fin de chantier:{" "}
                                            </span>
                                            {infosProjet.dateFinReel
                                                ? formatDate(
                                                      infosProjet.dateFinReel
                                                          .date
                                                  )
                                                : "Non renseignée"}
                                            <br></br>
                                        </>
                                    ) : null}
                                    {/* <span className="yellow">Date Etape:</span>{" "}
                                    {infosProjet.date_etape
                                        ? formatDate(infosProjet.date_etape.date)
                                        : "Non définie"}
                                    <span className="yellow">Date Etape:</span>{" "}
                                    {infosProjet.date_etape
                                        ? formatDate(infosProjet.date_etape.date)
                                        : "Non définie"} */}
                                </p>
                            </InfosCard>
                            <InfosCard>
                                <h2 className="yellow">Contact référent:</h2>{" "}
                                <p>
                                    {infosProjet.contact.nom}{" "}
                                    {infosProjet.contact.prenom} (
                                    {infosProjet.contact.sexe}){" "}
                                    <span className="yellow">Fonction:</span>{" "}
                                    {infosProjet.contact.fonction}
                                </p>
                                <p>
                                    <span className="yellow">Téléphone:</span>{" "}
                                    {infosProjet.contact.tel ??
                                        " Non renseignée"}{" "}
                                    <span className="yellow">Email:</span>{" "}
                                    {infosProjet.contact.mail ??
                                        " Non renseignée"}
                                </p>
                                <p>
                                    <span className="yellow">Adresse:</span>{" "}
                                    {infosProjet.contact.adresse ??
                                        " Non renseignée"}
                                </p>
                                <p>
                                    {infosProjet.contact.CP ?? " Non renseigné"}{" "}
                                    {infosProjet.contact.ville ??
                                        " Non renseignée"}
                                </p>
                            </InfosCard>
                        </div>
                        <div>
                            <InfosCard>
                                <p className="titreListe">
                                    <span className="yellow">
                                        Liste des utilisateurs du CRM
                                    </span>
                                    <button
                                        className="addDeleteBtn"
                                        onClick={() => handleClick("addUser")}
                                    >
                                        <img src={plus_icone} alt="add" />
                                    </button>
                                    <button
                                        className="addDeleteBtn"
                                        onClick={() => {
                                            // Vérifie si CRMUsers est vide ou non défini
                                            if (
                                                !infosProjet.CRMUsers ||
                                                infosProjet.CRMUsers.length ===
                                                    0
                                            ) {
                                                return;
                                            } else handleClick("deleteUser");
                                        }}
                                    >
                                        <img src={minus_icone} alt="delete" />
                                    </button>
                                </p>
                                <ul>
                                    {infosProjet.CRMUsers.map(
                                        (object, index) => {
                                            return (
                                                <li key={index}>
                                                    {object.prenom +
                                                        " " +
                                                        object.nom.toUpperCase()}
                                                </li>
                                            );
                                        }
                                    )}
                                </ul>
                            </InfosCard>
                            <InfosCard>
                                <p className="titreListe">
                                    <span className="yellow">Documents</span>
                                    <button
                                        className="addDeleteBtn"
                                        onClick={() => handleClick("addDoc")}
                                    >
                                        <img src={plus_icone} alt="add" />
                                    </button>
                                    <button
                                        className="addDeleteBtn"
                                        onClick={() => {
                                            // Vérifie si CRMUsers est vide ou non défini
                                            if (
                                                !infosProjet.documents ||
                                                infosProjet.documents.length ===
                                                    0
                                            ) {
                                                return;
                                            } else handleClick("deleteDoc");
                                        }}
                                    >
                                        <img src={minus_icone} alt="delete" />
                                    </button>
                                </p>
                                <ul>
                                    {infosProjet.documents.map(
                                        (object, index) => {
                                            return (
                                                <div key={index}>
                                                    <li>
                                                        <button
                                                            className="btnDownLoad"
                                                            onClick={() =>
                                                                handleDownLoad(
                                                                    object.id,
                                                                    object.nom
                                                                )
                                                            }
                                                        >
                                                            {object.nom}
                                                        </button>
                                                    </li>
                                                    <hr></hr>
                                                </div>
                                            );
                                        }
                                    )}
                                </ul>
                            </InfosCard>
                        </div>
                    </div>
                </div>

                <ChoiceButtons>
                    <button
                        onClick={() => handleClose()}
                        className="btnModal btnModal2"
                    >
                        Fermer
                    </button>
                    {(listStatutDevis.includes(infosProjet.statut) ||
                        listStatutFacture.includes(infosProjet.statut)) && (
                        <button
                            onClick={() =>
                                handleClickDF(
                                    listStatutDevis.includes(infosProjet.statut)
                                        ? "Devis"
                                        : "Facture"
                                )
                            }
                            className="btnModal btnModal1"
                        >
                            {listStatutDevis.includes(infosProjet.statut) &&
                                "Editer un devis"}
                            {listStatutFacture.includes(infosProjet.statut) &&
                                "Éditer la ou les factures"}
                        </button>
                    )}
                </ChoiceButtons>
            </ModalContainer>
            {showModalInfosProjetChange && mode !== "" && (
                <ModalInfoChange
                    mode={mode}
                    handleCloseInfoChange={() => handleCloseInfoChange()}
                    infosProjet={infosProjet}
                    listUser={listUser}
                ></ModalInfoChange>
            )}
            {showModalDevisFacture && typeDF !== "" && (
                <ModalDevisFacture
                    type={typeDF}
                    handleCloseDF={() => handleCloseDF()}
                    infosProjet={infosProjet}
                ></ModalDevisFacture>
            )}
        </Modal>
    );
};

export default ModalInfosProjet;
